export const isCouponNotFound = (state) => state.payment.invalidCouponCode;
